import { RETRIEVE_ORGANIZATION_ACCOUNT } from './constants';

const MOCK_ADMIN_ACCOUNT = {
  isAdmin: true,
  organization: {
    name: 'Company A',
    registeredTime: new Date().getTime(),
    registrationStatus: 'TRIAL',
  },
};

export function retrieveOrganizationAccount(props = {}) {
  return dispatch => {
    dispatch({
      type: RETRIEVE_ORGANIZATION_ACCOUNT,
      data: MOCK_ADMIN_ACCOUNT,
    });
  };
}

export function reducer(state, action) {
  if (action.type === RETRIEVE_ORGANIZATION_ACCOUNT) {
    const { isAdmin, organization } = action.data;
    return {
      ...state,
      isAdmin: isAdmin,
      organization: { ...organization },
    };
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/features/user-management/redux/retrieveOrganizationAccount.js